import React from "react";
import InteractiveFAQ from "./components/InteractiveFAQ";
import QuestionResultPage from "./components/QuestionResultPage";
import { Route, Routes } from "react-router-dom";

function App() {
  // Toggle between the live FAQ flow and the static result page for preview

  return (
    <Routes>
      <Route path="/" element={<InteractiveFAQ />} />
      <Route path="/poll-results" element={<QuestionResultPage />} />
    </Routes>
  );
}

export default App;
